<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Online Patients</li>
  </app-tabs>
  <app-appointment-listing class="flex-control flex-column" [hidden]="tabs_service.is_active()" [providers]="providers" [locations]="locations"></app-appointment-listing>
</div>
